var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"map-zoom-level my-0 pa-1 px-2",attrs:{"no-gutters":""}},[_vm._v("\n  "+_vm._s(`${_vm.$i18n.t('default.zoomLevel')}: ${_vm.computedZoomLevel}`)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }